module.exports = __webpack_public_path__ + "static/media/logo.607d3742.svg";